export default __webpack_public_path__ + "static/media/hannah-portrait.49027253.jpg";